export default "__VITE_ASSET__BrroLwq7__"